import React from 'react'
import gql from 'graphql-tag'
import _, { uniqueId } from 'lodash'
import {
  Query
} from 'react-apollo'

import GraphqlQuery from '../../molecules/GraphqlQuery'
import ResearchResult from './ResearchResult'

const SELECTED_THEME = gql`
  query ResearchResultContainerSelectedTheme {
    research @client {
      selectedTheme {
        id
        name
      }
    }
  }
`

const MAIN_QUERY = gql`
  query ResearchResultContainerMainQuery($id: Int!) {
    surveyByThemes(id: $id) {
      id
      name: nome
    }

    research @client {
      selectedCategories
      selectedTerritoryType
      selectedProducts
      selectedMeasurementUnit            
      selectedPeriod {
        start
        end
      }
      selectedTerritories {
        id
        name
        cd_muns
        isAggregated
        kind
      }
      landTenureFilters {
        categories
        subcategories
        themes
        subthemes
        sizes
        measurement
      }
      landTenureYear
    }
  }
`

const REGIONS_QUERY = gql`
  query ResearchResultRegionsQuery(
    $surveyIds: [Int!],
    $productIds: [Int!],
    $measurementUnitId: Int!,
    $period: Period!,
    $territoryIds: [Int!]
  ) {
    surveyResultByClipping(
      survey_ids: $surveyIds,
      product_ids: $productIds,
      measurement_unit_id: $measurementUnitId,
      period: $period,
      territory_ids: $territoryIds
    ) {
      pesquisa
      produto
      grandeza
      valor
      unidade
      territorio
      ano
    }
  }
`

const BIOMES_BIOME_QUERY = gql`
  query ResearchResultRegionsQuery(
    $surveyIds: [Int!],
    $productIds: [Int!],
    $measurementUnitId: Int!,
    $period: Period!,
    $biomeIds: [Int!]
  ) {
    surveyResultByBiome(
      survey_ids: $surveyIds,
      product_ids: $productIds,
      measurement_unit_id: $measurementUnitId,
      period: $period,
      biome_ids: $biomeIds
    ) {
      pesquisa
      produto
      grandeza
      valor
      unidade
      territorio
      ano
    }
  }
`

const BIOMES_CITY_QUERY = gql`
  query ResearchResultRegionsQuery(
    $surveyIds: [Int!],
    $productIds: [Int!],
    $measurementUnitId: Int!,
    $period: Period!,
    $territoryIds: [Int!]
  ) {
    surveyClippingResultByBiome(
      survey_ids: $surveyIds,
      product_ids: $productIds,
      measurement_unit_id: $measurementUnitId,
      period: $period,
      territory_ids: $territoryIds
    ) {
      pesquisa
      produto
      grandeza
      valor
      unidade
      territorio
      ano
    }
  }
`

export default class ResearchResultContainer extends React.PureComponent {
  generateRenderRegionsResultFunction(variables) {
    return (children) => (
      <GraphqlQuery
        fetchPolicy="network-only"
        query={ REGIONS_QUERY }
        variables={ variables }
      >
        { ({ surveyResultByClipping }) => children(surveyResultByClipping) }
      </GraphqlQuery>
    )
  }

  generateRenderBiomeResultFunction(variables) {
    return (children) => (
      <GraphqlQuery
        fetchPolicy="network-only"
        query={ BIOMES_BIOME_QUERY }
        variables={ variables }
      >
        {({ surveyResultByBiome }) => (
          <GraphqlQuery
            fetchPolicy="network-only"
            query={ BIOMES_CITY_QUERY }
            variables={ variables }
          >
            {({ surveyClippingResultByBiome }) => (
              children(_.concat(surveyClippingResultByBiome, surveyResultByBiome))
            )}
          </GraphqlQuery>
        )}
      </GraphqlQuery>
    )
  }

  generateRenderQueryFunction(surveys, researchState, themeName) {
    let surveyIds = _.map(surveys, 'id')
    let territoryIds = _.map(researchState.selectedTerritories, 'id')

    let variables = {
      surveyIds,
      territoryIds,
      measurementUnitId: researchState.selectedMeasurementUnit,
      productIds: researchState.selectedProducts,
      biomeIds: territoryIds,
      period: {
        start: researchState.selectedPeriod.start,
        end: researchState.selectedPeriod.end
      }
    }

    if (themeName === 'PECUARIA_ABATE') {
      variables.surveyIds = []
      if (_.includes(researchState.selectedCategories, 1)) {
        variables.surveyIds.push(1)
      }

      if (_.includes(researchState.selectedCategories, 2)) {
        variables.surveyIds.push(2)
      }

      if (_.includes(researchState.selectedCategories, 3)) {
        variables.surveyIds.push(3)
      }
    }

    if (researchState.selectedTerritoryType === 'regions') {
      return this.generateRenderRegionsResultFunction(variables)
    } else {
      return this.generateRenderBiomeResultFunction(variables)
    }
  }

  getSearchSeed(research) {
    return 'search-' + Date.now();
  }

  renderComponent = ({ surveyByThemes, research }, theme) => (
    <ResearchResult
      renderQuery={ this.generateRenderQueryFunction(surveyByThemes, research, theme.name) }
      selectedTheme={ theme }
      themes={ this.props.themes }
      landTenureFilters={ research.landTenureFilters }
      landTenureYear={ research.landTenureYear }
      selectedTerritoryType={ research.selectedTerritoryType }
      selectedMeasurementUnit={ research.selectedMeasurementUnit }
      selectedPeriod={ research.selectedPeriod }
      selectedProducts={ _.reject(research.selectedProducts, (el) => el === 0) }
      selectedTerritories={ _.reject(research.selectedTerritories, (el) => el === 0) }
      seed={ this.getSearchSeed(research) }
    />
  )

  renderSelectedThemeQuery = ({ data }) => (
    <GraphqlQuery
      query={ MAIN_QUERY }
      variables={{
        id: data.research.selectedTheme.id
      }}
    >
      { (result) => (
        this.renderComponent(result, data.research.selectedTheme)
      ) }
    </GraphqlQuery>
  )

  render() {
    return (
      <Query query={ SELECTED_THEME }>
        { this.renderSelectedThemeQuery }
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/ResearchResult/ResearchResult.container.js